import { z } from "zod/v4";

import { BulletinStatus, PublicationChannel } from "../enums/enums";
import { DateSchema } from "./bulletin.model";

export const ChecklistItemSchema = z.object({
  publicationChannel: z.enum(PublicationChannel),
  ok: z.boolean().optional(),
  problemDescription: z.string(),
});

export type ChecklistItemModel = z.infer<typeof ChecklistItemSchema>;

export const PublicationChecklistSchema = z.object({
  checklistId: z.string().optional(),
  timestamp: DateSchema.nullish(),
  checklistItems: ChecklistItemSchema.array(),
  user: z.string().optional(),
});

export type PublicationChecklistModel = z.infer<typeof PublicationChecklistSchema>;

const PublicationBulletinStatusSchema = z.preprocess((value) => {
  if (typeof value === "string") {
    return BulletinStatus[value as keyof typeof BulletinStatus];
  }
  return value;
}, z.enum(BulletinStatus));

export const PublicationStatusSchema = z.object({
  date: DateSchema.nullish(),
  timestamp: DateSchema.nullish(),
  status: PublicationBulletinStatusSchema,
  isBeingPublished: z.boolean().optional(),
});

export type PublicationStatusModel = z.infer<typeof PublicationStatusSchema>;
